import { Inject, Injectable } from '@angular/core';

export class Environment {
  apiUrl: string;
  workflowsApiUrl?: string;
  raterApiUrl?: string;
  eventsApiUrl?: string;
  dromoLicenseKey?: string;
  covieAccessKey?: string;
  S3_BUCKET_URL?: string;
  intakeFormUrl?: string;
  xaiApiUrl?: string;
  pagesApiUrl?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private environment: Environment;

  get apiUrl() {
    return this.environment?.apiUrl;
  }

  get workflowsApiUrl() {
    return this.environment?.workflowsApiUrl;
  }

  get raterApiUrl() {
    return this.environment?.raterApiUrl;
  }

  get dromoLicenseKey() {
    return this.environment?.dromoLicenseKey;
  }

  get covieAccessKey() {
    return this.environment?.covieAccessKey;
  }

  get s3BucketUrl() {
    return this.environment?.S3_BUCKET_URL;
  }

  get intakeFormUrl() {
    return this.environment?.intakeFormUrl;
  }

  get eventsApiUrl() {
    return this.environment?.eventsApiUrl;
  }

  get xaiApiUrl() {
    return this.environment?.xaiApiUrl;
  }

  get pagesApiUrl() {
    return this.environment?.pagesApiUrl;
  }

  constructor(@Inject(Environment) environment) {
    this.environment = { ...environment };
    if (this.environment.apiUrl.endsWith('/')) {
      this.environment.apiUrl = this.environment.apiUrl.slice(0, -1);
    }
  }
}
